var map = {
	"./1112111.png": 7210,
	"./Arrow.png": 4571,
	"./Hamed.png": 473,
	"./LASTMILE.png": 7769,
	"./ProposalWhite.png": 4313,
	"./Rectangle-19858.png": 8953,
	"./Rectangle-19866.png": 6442,
	"./Rectangle-19866.webp": 14,
	"./Rectangle-19867.webp": 6089,
	"./Site.png": 4051,
	"./SiteWhite.png": 7324,
	"./Values.png": 7632,
	"./Vision.png": 7358,
	"./about.jpg": 6979,
	"./about.png": 715,
	"./bhahameed.png": 7519,
	"./card1.png": 1255,
	"./col1.jpg": 5713,
	"./cole2.jpg": 1283,
	"./cole2.png": 8667,
	"./cole3.png": 3842,
	"./email.png": 2920,
	"./handColor.png": 580,
	"./hassan.jpg": 8028,
	"./heroBanner.jpg": 7756,
	"./john.png": 4697,
	"./logo-TwoNames.png": 7336,
	"./logo-placeholder.png": 9659,
	"./mapCurrent.png": 4703,
	"./messageColor.png": 1484,
	"./messages.png": 2426,
	"./mission.jpg": 7782,
	"./mission.png": 3506,
	"./ordinary.jpg": 8340,
	"./ordinary.png": 9024,
	"./second.jpg": 5886,
	"./second.png": 3658,
	"./settingsColor.png": 7840,
	"./settingsWhite.png": 8738,
	"./slider1.png": 8704,
	"./slider2.png": 7035,
	"./slider3.png": 5858,
	"./slider4.png": 717,
	"./slider5.png": 6820,
	"./solarimage1.jpg": 555,
	"./solarimage2.jpg": 4108,
	"./solarimage3.jpg": 1897,
	"./solarimage4.jpg": 2410,
	"./solarimage5.jpg": 4343,
	"./solarimage6.jpg": 5672,
	"./systemDesign.png": 3775,
	"./team2.png": 6067,
	"./team3.png": 8490,
	"./team4.png": 4997,
	"./uluslararasi-lojistik.png": 7246,
	"./values.jpg": 1572,
	"./vission.jpg": 8689,
	"./vtvMainWhy.jpg": 4101,
	"./vtvMainWhy.png": 9637,
	"./vtvSolarenergy.jpg": 8785,
	"./vtvSolarenergy.png": 5897,
	"./withvtv.png": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7616;